function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "47BC11A3-0CA5-48F1-9220-007C8F205664");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.8156279,18.6600061 C10.8220198,19.6462559 10.8556071,20.1900641 10.9659373,20.8336566 C11.3230658,22.9169065 12.4308393,24.3708591 14.8008081,25.2925136 C15.0175373,25.3767972 15.1249057,25.6208164 15.0406221,25.8375456 C14.9563385,26.0542748 14.7123194,26.1616433 14.4955902,26.0773597 C11.8393647,25.0443831 10.5413285,23.3407107 10.1359396,20.9759419 C10.0155988,20.273954 9.98001647,19.6953738 9.97349258,18.6600061 L5.54755318,18.6600061 C3.8806816,18.6600061 2.52631579,17.3302652 2.52631579,15.6860449 L2.52631579,12.2821668 C2.52631579,10.6379465 3.8806816,9.30820554 5.54755318,9.30820554 L10.3834267,9.30832013 C10.3867257,9.30824382 10.3900341,9.30820545 10.3933515,9.30820545 C10.3966757,9.30820545 10.3999909,9.30824398 10.4032967,9.3083206 L13.3356427,9.30839008 C17.9189594,9.17264721 22.3606483,7.71900362 26.109644,5.1280305 C26.3889279,4.93501421 26.7700838,5.13491853 26.7700838,5.47441052 L26.7700838,10.4137531 C27.5322666,10.5666385 28.1963767,11.1291642 28.5736831,11.9460566 C29.005449,12.8808572 29.005449,14.0236424 28.5736831,14.958443 C28.1963767,15.7753355 27.5322666,16.3378611 26.7700838,16.4907465 L26.7700838,22.4938011 C26.7700838,22.8385575 26.3784092,23.0371971 26.1002609,22.833505 C22.4157578,20.1352882 17.9444185,18.6719408 13.3481074,18.6600061 L11.6146509,18.6600061 L10.8156279,18.6600061 Z M10.8144041,10.1503109 L10.8144041,17.8179013 L11.6146509,17.8179013 L13.3492006,17.8179027 C17.8493041,17.8295862 22.233572,19.1802467 25.9279785,21.6822635 L25.9279785,6.26145022 C22.188717,8.66899474 17.8390859,10.0174771 13.3481074,10.1503109 L10.8144041,10.1503109 Z M9.97229887,17.8179013 L9.97229887,10.1503109 L5.54755316,10.1503109 C4.34233997,10.1503109 3.36842105,11.1065222 3.36842105,12.282167 L3.36842105,15.6860452 C3.36842105,16.86169 4.34233997,17.8179013 5.54755316,17.8179013 L9.97229887,17.8179013 Z M26.7700838,15.6201605 C27.1934491,15.4768419 27.5713073,15.1203574 27.8091852,14.6053365 C28.1374746,13.894569 28.1374746,13.0099307 27.8091852,12.2991631 C27.5713073,11.7841423 27.1934491,11.4276577 26.7700838,11.2843392 L26.7700838,15.6201605 Z",
  id: "path-4"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Users",
  transform: "translate(-1229.000000, -123.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blog/not-se;ected",
  transform: "translate(1227.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Dashboard-Copy"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#EAECF0",
  fillRule: "nonzero",
  xlinkHref: "#path-4"
}), /*#__PURE__*/React.createElement("g", {
  id: "Color/Primary/Brand",
  mask: "url(#mask-4)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.240602, -0.376005)",
  id: "Rectangle-Copy-3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 32,
  height: 32
})))))))));

var SvgBlog = function SvgBlog(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    fill: "#9FA5B7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Blog.d160633c.svg";
export { ForwardRef as ReactComponent };